import { computed } from 'vue';
import { useRoute } from 'vue-router';

import * as socialListeningApi from '@/apis/social-listening';
import { SOCIAL_LISTENING_ROUTE_NAMES } from '@/app/socialListening/constants';
import { useIdentityStore } from '@/stores/identity';

export function useSocialListening() {
  const route = useRoute();
  const identityStore = useIdentityStore();

  const organizationId = computed(() => identityStore.currentBrand?.organizationId);
  const currentBrandId = computed(() => identityStore.currentBrand?.id);

  const isTopicsPage = computed(() => route.name === SOCIAL_LISTENING_ROUTE_NAMES.TOPICS);

  const isTrendsPage = computed(
    () =>
      route.name === SOCIAL_LISTENING_ROUTE_NAMES.TRENDS ||
      route.name === SOCIAL_LISTENING_ROUTE_NAMES.TRENDS_REPORT,
  );

  const isOverviewPage = computed(() => route.name === SOCIAL_LISTENING_ROUTE_NAMES.OVERVIEW);

  const isComparisonPage = computed(
    () => route.name === SOCIAL_LISTENING_ROUTE_NAMES.TOPIC_COMPARISONS,
  );

  async function getTimeSeriesPostVolume(
    payload,
    signal,
    useEstimates = { useEstimates: false },
    teaserEndpoint = false,
  ) {
    const getFunction = teaserEndpoint
      ? socialListeningApi.getTeaserTimeSeriesPostVolume
      : socialListeningApi.getTimeSeriesPostVolume;

    const res = await getFunction(
      { organizationId: organizationId.value, payload, useEstimates },
      { signal },
    );
    return res.data.data;
  }

  async function getTopKeywords({
    payload,
    signal,
    useEstimates = { useEstimates: false },
    teaserEndpoint = false,
  }) {
    const getFunction = teaserEndpoint
      ? socialListeningApi.getTeaserTopKeywords
      : socialListeningApi.getTopKeywords;

    const res = await getFunction(
      {
        organizationId: organizationId.value,
        payload,
        useEstimates,
      },
      { signal },
    );
    return res.data.data;
  }

  return {
    organizationId,
    currentBrandId,
    getTimeSeriesPostVolume,
    getTopKeywords,
    isTopicsPage,
    isTrendsPage,
    isOverviewPage,
    isComparisonPage,
  };
}
